<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="配置项名称" prop="Name">
                <el-input size="small" v-model="model.Name" auto-complete="off" placeholder="请输入配置项名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="配置项英文key" prop="Key">
                <el-input size="small" v-model="model.Key" auto-complete="off" placeholder="请输入配置项英文key" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {UpdateSetting} from '../../api/setting'
export default {
    data() {
        return {
            title: '编辑配置项',
            name: 'add',
            model: {
                OID: null,
                Name: null,
                Key: '',
            },
            rules: {
                Name: [{ required: true, message: '请输入配置项名称', trigger: 'blur' }],
                Key: [{ required: true, message: '请输入配置项英文key', trigger: 'blur' }],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        data: {
            required: true,
            type: Object
        }
    },  
    mounted() {
        this.model = this.data;
    },
    methods: {
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.UpdateSetting()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeEditDialog')
        },
        UpdateSetting() {
            UpdateSetting(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
        done(input){
            var regex = /^[0-9A-Za-z]+$/;
            if (input.match(regex)) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>

<style>

</style>